<script>
import replyTabProductSection from "@core/mixins/ui/reply-tab-product-section";
import ProductMaterialMixtureCategorySelector from "@/views/product/components/product-card/common/categories";

export default {
    mixins: [replyTabProductSection],
    components: {
        ProductMaterialMixtureCategorySelector,
    },
    props: {
        section: {
            default() {
                return {
                    name: null,
                    id: null,
                    scipName: null
                };
            }
        }
    },
    computed: {
        showMaterialMixtureCategories() {
            return (this.section.materialCategoryIds || []).length > 0
                || (this.section.mixtureCategoryIds || []).length > 0;
        },
    },
}
</script>

<template>
    <div>
        <div class="pb-1 pt-1">
            <h3>{{ $t('Page(SentRequest):Component(Text):product-information') }}</h3>
        </div>
        <table>
            <tbody>
            <tr>
                <th>{{ supplierNameLabel }}:</th>
                <td>
                    <span class="alert-warning pl-1 pr-1">{{ section.name }}</span>
                </td>
            </tr>
            <tr>
                <th>{{ supplierIdLabel }}:</th>
                <td>
                    <span class="alert-warning pl-1 pr-1">{{ section.id }}</span>
                </td>
            </tr>
            <tr>
                <th>{{ scipNameLabel }}:</th>
                <td>
                    <span class="alert-warning pl-1 pr-1">{{ section.scipName }}</span>
                </td>
            </tr>
            <tr>
                <th>{{ scipNumberLabel }}:</th>
                <td>
                    <span class="alert-warning pl-1 pr-1">{{ section.scipId }}</span>
                </td>
            </tr>
            <tr>
                <th>{{ $t('Page(SentRequest):Component(Text):product-information-categories') }}:</th>
                <td>
                    <span class="alert-warning pl-1 pr-1">{{ section.categories.map(c => c.code).filter(c => c).join(', ') }}</span>
                </td>
            </tr>
            <tr>
                <th>{{ $t('Component(Label):manufacturing-origin') }}:</th>
                <td>
                    <span class="alert-warning pl-1 pr-1">{{ section.countryOfOrigin ? section.countryOfOrigin.title : '' }}</span>
                </td>
            </tr>
            <tr v-if="section.weight">
                <th>{{ $t('Component(Placeholder):product-weight') }}</th>
                <td><span class="pl-1 pr-1">{{ section.weight }}</span></td>
            </tr>
            </tbody>
        </table>
        <ProductMaterialMixtureCategorySelector
            v-if="showMaterialMixtureCategories"
            class="mt-1"
            read-only
            :material-category-ids="section.materialCategoryIds"
            :mixture-category-ids="section.mixtureCategoryIds"
        />
    </div>
</template>
